import { request } from '../request';

export const rootApi = {
  readRoot: () => request('/'),
  getVersion: () => request('/version')
};
